import { localization as l } from "@/lib/localization";

type Props = {
    links: { label: string, href: string }[]
}

export default function ChatTopLinks({ links }: Props) {
    return (
        <div className="tw-w-full tw-p-4 tw-ps-0">
            <h3 className="tw-text-lg tw-font-bold">{l["Welcome to the DPJ Chat"]}</h3>
            {links.length > 0 && (
                <>
                    <p>{l["Here are some helpful links to get you started"]}</p>
                    <ul className="tw-ps-6">
                        {links.map((link) => (
                            <li className="tw-pb-2" key={link.href}>
                                <a className="tw-underline" href={link.href}>{link.label}</a>
                            </li>
                        ))}
                    </ul>
                </>
            )}
        </div>
    )
}